import { render } from "./ViewerConfig.vue?vue&type=template&id=b35035d6&scoped=true"
import script from "./ViewerConfig.vue?vue&type=script&lang=js"
export * from "./ViewerConfig.vue?vue&type=script&lang=js"

import "./ViewerConfig.vue?vue&type=style&index=0&id=b35035d6&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35035d6"]])

export default __exports__